import styled, { css } from "styled-components"
import loaderImg from "../../../images/loader.svg"

export const buttonStyles = css`
  --button-height: 50px;

  // Box
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  height: var(--button-height);
  background-color: ${({ theme }) => theme.color.button};

  // Border
  border: none;
  border-radius: ${({ theme }) => theme.size.borderRadius};
  outline: none;
  box-shadow: 0 2px 20px 0 ${({ theme }) => theme.color.lightShadow};

  // Spacing
  margin: 0;
  padding: 0 25px;
  overflow: hidden;

  // Font
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${13 / 16}rem;
  font-weight: 500;
  color: ${({ theme }) => theme.color.textInverted};
  line-height: var(--button-height);
  text-transform: uppercase;
  text-align: center;
  white-space: nowrap;
  letter-spacing: 2px;

  // Effects
  cursor: pointer;
  appearance: none;
  transition: background 0.15s ease-in-out;

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.color.buttonActive};
    color: ${({ theme }) => theme.color.textInverted};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.color.placeholder};
    cursor: not-allowed;
  }
`

export const largeButtonStyles = css`
  --button-height: 56px;
`

export const Button = styled.button<{ pending?: boolean; large?: boolean }>`
  ${buttonStyles};
  ${({ large }) => large && largeButtonStyles};
  ${({ pending }) =>
    pending &&
    css`
      pointer-events: none;
      color: transparent;

      &::after {
        position: absolute;
        top: 0;
        left: 0;

        display: inline-block;
        content: "";
        width: 100%;
        height: 100%;

        pointer-events: none;

        background-color: inherit;
        background-repeat: no-repeat;
        background-position: center center;
        background-image: url(${loaderImg});
      }
    `}
`
